"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CoverageEligibilityResponse = exports.CoverageEligibilityResponseOutcomeKind = exports.CoverageEligibilityResponsePurposeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_CoverageEligibilityResponse_Insurance_1 = require("./RTTI_CoverageEligibilityResponse_Insurance");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_CoverageEligibilityResponse_Error_1 = require("./RTTI_CoverageEligibilityResponse_Error");
var CoverageEligibilityResponsePurposeKind;
(function (CoverageEligibilityResponsePurposeKind) {
    CoverageEligibilityResponsePurposeKind["_authRequirements"] = "auth-requirements";
    CoverageEligibilityResponsePurposeKind["_benefits"] = "benefits";
    CoverageEligibilityResponsePurposeKind["_discovery"] = "discovery";
    CoverageEligibilityResponsePurposeKind["_validation"] = "validation";
})(CoverageEligibilityResponsePurposeKind = exports.CoverageEligibilityResponsePurposeKind || (exports.CoverageEligibilityResponsePurposeKind = {}));
var CoverageEligibilityResponseOutcomeKind;
(function (CoverageEligibilityResponseOutcomeKind) {
    CoverageEligibilityResponseOutcomeKind["_queued"] = "queued";
    CoverageEligibilityResponseOutcomeKind["_complete"] = "complete";
    CoverageEligibilityResponseOutcomeKind["_error"] = "error";
    CoverageEligibilityResponseOutcomeKind["_partial"] = "partial";
})(CoverageEligibilityResponseOutcomeKind = exports.CoverageEligibilityResponseOutcomeKind || (exports.CoverageEligibilityResponseOutcomeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CoverageEligibilityResponse = t.recursion('ICoverageEligibilityResponse', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('CoverageEligibilityResponse'),
            patient: RTTI_Reference_1.RTTI_Reference,
            request: RTTI_Reference_1.RTTI_Reference,
            insurer: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            purpose: t.array((0, EnumType_1.createEnumType)(CoverageEligibilityResponsePurposeKind, 'CoverageEligibilityResponsePurposeKind')),
            _purpose: t.array(RTTI_Element_1.RTTI_Element),
            servicedDate: t.string,
            _servicedDate: RTTI_Element_1.RTTI_Element,
            servicedPeriod: RTTI_Period_1.RTTI_Period,
            created: RTTI_dateTime_1.RTTI_dateTime,
            _created: RTTI_Element_1.RTTI_Element,
            requestor: RTTI_Reference_1.RTTI_Reference,
            outcome: (0, EnumType_1.createEnumType)(CoverageEligibilityResponseOutcomeKind, 'CoverageEligibilityResponseOutcomeKind'),
            _outcome: RTTI_Element_1.RTTI_Element,
            disposition: t.string,
            _disposition: RTTI_Element_1.RTTI_Element,
            insurance: t.array(RTTI_CoverageEligibilityResponse_Insurance_1.RTTI_CoverageEligibilityResponse_Insurance),
            preAuthRef: t.string,
            _preAuthRef: RTTI_Element_1.RTTI_Element,
            form: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            error: t.array(RTTI_CoverageEligibilityResponse_Error_1.RTTI_CoverageEligibilityResponse_Error)
        })
    ]);
});
//# sourceMappingURL=RTTI_CoverageEligibilityResponse.js.map